import script from "./WapApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapApp.vue?vue&type=script&lang=ts&setup=true"

import "./WapApp.vue?vue&type=style&index=0&id=777577d9&lang=css"
import "./WapApp.vue?vue&type=style&index=1&id=777577d9&scoped=true&lang=css"
import "./WapApp.vue?vue&type=style&index=2&id=777577d9&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777577d9"]])

export default __exports__